import { combineReducers } from 'redux';

import OlympicQuizReducer from "views/user/OlympicViewer/reducers";
const rootReducer = combineReducers({
  OlympicQuizReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;